// Shared vehicle type options used across the Vehicle module.
// `value` must match the backend VehicleType enum values.
export const VEHICLE_TYPE_OPTIONS = [
  { value: 'cargo_goods', label: 'Truck' },
  { value: 'bus', label: 'Bus' },
  { value: 'single_axle', label: 'Single Axle' },
  { value: 'multi_axle', label: 'Multi Axle' },
  { value: 'container', label: 'Container' },
];

const VEHICLE_TYPE_LABELS = VEHICLE_TYPE_OPTIONS.reduce((acc, opt) => {
  acc[opt.value] = opt.label;
  return acc;
}, {});

export const formatVehicleType = (value) => {
  if (!value) return '';
  return (
    VEHICLE_TYPE_LABELS[value] ||
    String(value)
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase())
  );
};
